const percentFormatters = new Map<number, Intl.NumberFormat>();

// formatPercent formats a probability (a fraction from 0 to 1) as a whole-number percentage, e.g. 0.723 -> "72%", or
// with `fractionDigits` decimal places, e.g. formatPercent(0.7234, 1) -> "72.3%".  Input outside [0, 1] (including
// +/-Infinity) is clamped, so 1.2 -> "100%" and -0.1 -> "0%".  NaN returns "—" (an em dash) because there is no
// meaningful number to show.  Values are rounded, so anything between 0 and 0.005 displays as "0%" and anything
// between 0.995 and 1 as "100%".
export const formatPercent = (probability: number, fractionDigits = 0): string => {
  if (Number.isNaN(probability)) {
    return '—';
  }
  let formatter = percentFormatters.get(fractionDigits);
  if (!formatter) {
    // The locale is fixed so the output is the same in every browser and in tests.
    formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
    percentFormatters.set(fractionDigits, formatter);
  }
  return formatter.format(Math.min(1, Math.max(0, probability)));
};
